const RelatedList = require('module/user/related_list')
const App = require('module/user/app')

const AppList = RelatedList.extend({

    id: 'apps',

    model: App,

    comparator: 'display_order',

    initialize() {
        this.listenTo(this, 'change:display_order', this.sort)
    },

})

module.exports = AppList
